import React from 'react';

export default function TemplatePreview({ previewUrl, onUpdate, updating }) {
  return (
    <div className="at-preview">
      <div className="at-preview-phone">
        {previewUrl ? (
          <img src={previewUrl} alt="Template preview" className="at-preview-image" />
        ) : (
          <div className="at-preview-placeholder">No preview yet</div>
        )}
      </div>
      {onUpdate && (
        <button type="button" className="at-btn at-btn-secondary at-preview-update" onClick={onUpdate} disabled={updating}>
          {updating ? 'Updating…' : 'Update Thumbnail'}
        </button>
      )}
    </div>
  );
}
